<template>
  <div class="hero">
    <video
      width="100%"
      height="100%"
      autoplay="autoplay"
      loop="loop"
      muted="muted"
      class="absolute"
      playsinline="playsinline"
      poster="../assets/placeholder-poster.jpg"
    >
      <source src="../assets/beer-movie.mp4" type="video/mp4" />
      <source src="../assets/beer-movie.webm" type="video/webm" />
      
      Sorry, your browser doesn't support embedded videos.
    </video>
  </div>
</template>

<script>
export default {
  name: "Hero"
};
</script>

<style>
.hero {
  position: relative;
  background-size: cover;
  text-align: center;
}

video {
  object-fit: fill;
}
</style>
